


















































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import BackgroundCheck from '~/components/UIComponents/BackgroundCheck.vue';

@Component({ components: { BackgroundCheck } })
export default class GoldUpgradeWidget extends Vue {
  galaCube = require('@/assets/icons/icon_gala_cube.png');

  get cubeWidth() {
    const { md, lgAndUp, sm } = this.$vuetify.breakpoint;
    return lgAndUp || sm ? '130px' : md ? '100px' : '80px';
  }

  get showSpiderTank() {
    const endTime = Date.UTC(2021, 6, 19, 0);
    const now = Date.now();

    return now < endTime;
  }

  get message() {
    return this.showSpiderTank
      ? 'Sign up for Gala Gold by July 18 and get this Uncommon Sentinel for Spidertanks!'
      : this.$t('components.home.widgets.goldUpgradeWidget.signUpCta');
  }

  goTo(route: string) {
    this.$router.push(route);
  }
}
